import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import { getLocalStorage } from '@/utils/tools.js'
// import login from './modules/login'
// import routeInfo from './modules/route'

Vue.use(Vuex)
// const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
  // modules: {
  //   // login,
  //   routeInfo
  // },
  // mutations,
  // strict: debug
  state: {
    routeInfo: {},
    mail: false,
    loginState: getLocalStorage('loginState') || false,
  },
  mutations: {
    [types.CHANGE_ROUTE_INFO] (state, payLoad) {
      state.routeInfo = payLoad;
    },
    [types.LOGIN_STATE] (state, payload) {
      state.loginState = payload;
    },
    [types.MAIL] (state, payload) {
      state.mail = payload;
    },
  }
})
